import { createFeatureSelector } from '@ngrx/store';

export const selectBranding = createFeatureSelector('branding');
